import { createContext, HTMLProps, useContext } from 'react';

import { ButtonType } from 'components/Form/Button/Button';

export type MenuContextValue = {
  getItemProps: (userProps?: HTMLProps<HTMLElement>) => Record<string, unknown>;
  activeIndex: number | null;
  setActiveIndex: (index: number | null) => void;
  setHasFocusInside: (value: boolean) => void;
  isOpen: boolean;
  size: ButtonType['size'];
};

export const MenuContext = createContext<MenuContextValue | null>(null);

export const useMenuContext = () => {
  const ctx = useContext(MenuContext);
  if (!ctx) {
    throw new Error('MenuButtonOption and MenuButtonNestedOption must be rendered inside <MenuButton>');
  }
  return ctx;
};

export type MenuListContextValue = {
  listItemsRef: { current: Array<HTMLElement | null> };
  listContentRef: { current: Array<string | null> };
  hasFocusInside: boolean;
  setHasFocusInside: (value: boolean) => void;
};

export const MenuListContext = createContext<MenuListContextValue | null>(null);

export const useMenuListContext = () => {
  const ctx = useContext(MenuListContext);
  if (!ctx) {
    throw new Error('MenuButtonOption and MenuButtonNestedOption must be rendered inside <MenuButton>');
  }
  return ctx;
};
